export const moodboardItems = [
  {
    id: "mb1",
    imageUrl: "https://public.readdy.ai/ai/img_res/459e32530b7a0c9cf0129bd5d08e5a80.jpg",
    tag: "청량 / 봄",
    mood: "청아한",
    color: "#FFB3C6",
  },
  {
    id: "mb2",
    imageUrl: "https://readdy.ai/api/search-image?query=dark%20moody%20kpop%20concept%20art%20neon%20lights%20futuristic%20cyberpunk%20deep%20black%20background%20glowing%20purple%20teal%20sharp%20dramatic%20contrast%20urban%20night%20city%20edgy%20bold&width=400&height=400&seq=mb2&orientation=squarish",
    tag: "다크 / 강렬",
    mood: "파워풀",
    color: "#9B5DE5",
  },
  {
    id: "mb3",
    imageUrl: "https://readdy.ai/api/search-image?query=retro%20vintage%2090s%20kpop%20nostalgia%20warm%20orange%20yellow%20sunset%20grain%20film%20photo%20analog%20vibe%20cozy%20soft%20focus%20warm%20tones%20summer%20memories%20aesthetic&width=400&height=400&seq=mb3&orientation=squarish",
    tag: "레트로 / 노스탤지어",
    mood: "따뜻한",
    color: "#FF9F43",
  },
  {
    id: "mb4",
    imageUrl: "https://readdy.ai/api/search-image?query=minimalist%20modern%20kpop%20concept%20clean%20geometric%20white%20space%20monochrome%20black%20white%20high%20fashion%20editorial%20luxury%20sleek%20sharp%20lines%20professional%20studio&width=400&height=400&seq=mb4&orientation=squarish",
    tag: "미니멀 / 하이패션",
    mood: "세련된",
    color: "#E0E4F0",
  },
  {
    id: "mb5",
    imageUrl: "https://readdy.ai/api/search-image?query=dreamy%20ocean%20beach%20summer%20kpop%20concept%20art%20bright%20turquoise%20blue%20sky%20white%20sand%20tropical%20fresh%20energetic%20fun%20youthful%20vivid%20colors%20vacation%20vibes&width=400&height=400&seq=mb5&orientation=squarish",
    tag: "썸머 / 에너제틱",
    mood: "발랄한",
    color: "#00C8FF",
  },
  {
    id: "mb6",
    imageUrl: "https://readdy.ai/api/search-image?query=dark%20forest%20mysterious%20fantasy%20kpop%20concept%20art%20misty%20fog%20deep%20green%20nature%20ethereal%20magical%20surreal%20cinematic%20atmospheric%20moody%20beautiful%20dramatic%20lighting&width=400&height=400&seq=mb6&orientation=squarish",
    tag: "미스터리 / 판타지",
    mood: "신비로운",
    color: "#00C896",
  },
];

export const demoTracks = [
  {
    id: "dt1",
    title: "Midnight Call",
    artist: "작곡가 한도현",
    genre: "R&B / Soul",
    bpm: 85,
    key: "Dm",
    duration: "3:24",
    price: 800,
    mood: "감성적",
    description: "깊은 밤 감성을 담은 R&B 트랙. 부드러운 피아노와 섬세한 보컬 멜로디 라인이 특징입니다.",
    tags: ["감성", "야간", "피아노", "R&B"],
    isNew: true,
    rating: 4.8,
  },
  {
    id: "dt2",
    title: "Nova Burst",
    artist: "작곡가 김세아",
    genre: "Dance Pop",
    bpm: 128,
    key: "G Major",
    duration: "3:10",
    price: 1200,
    mood: "에너제틱",
    description: "BPM 128의 청량 댄스팝. 후킹한 훅(Hook) 섹션과 전자음이 어우러진 무대 최적화 곡.",
    tags: ["댄스", "청량", "후킹", "팝"],
    isNew: true,
    rating: 4.9,
  },
  {
    id: "dt3",
    title: "Forgotten Rain",
    artist: "작곡가 박지훈",
    genre: "Ballad",
    bpm: 68,
    key: "Am",
    duration: "4:05",
    price: 950,
    mood: "애절한",
    description: "슬픔과 그리움을 담은 정통 발라드. 오케스트라 편곡 버전도 제공됩니다.",
    tags: ["발라드", "감성", "오케스트라"],
    isNew: false,
    rating: 4.7,
  },
  {
    id: "dt4",
    title: "Electric Youth",
    artist: "작곡가 이수진",
    genre: "Synth Pop",
    bpm: 115,
    key: "E Major",
    duration: "3:35",
    price: 1100,
    mood: "레트로",
    description: "90년대 신스팝에서 영감을 받은 트랙. 레트로 신디사이저와 현대적 프로덕션의 조합.",
    tags: ["레트로", "신스팝", "청량"],
    isNew: false,
    rating: 4.6,
  },
  {
    id: "dt5",
    title: "Shadow Walk",
    artist: "작곡가 최민준",
    genre: "Hip-Hop / Trap",
    bpm: 140,
    key: "Cm",
    duration: "3:18",
    price: 1300,
    mood: "강렬한",
    description: "묵직한 808 베이스와 날카로운 하이햇이 특징인 트랩 비트. 강렬한 퍼포먼스용.",
    tags: ["트랩", "힙합", "강렬", "비트"],
    isNew: true,
    rating: 4.8,
  },
];

export const composerRequests = [
  {
    id: "cr1",
    requestedBy: "A&R팀",
    genre: "Dance Pop",
    bpmRange: "120-130",
    mood: "청량",
    deadline: "2026.04.05",
    status: "제작중",
    composer: "김세아",
  },
  {
    id: "cr2",
    requestedBy: "마케팅팀",
    genre: "Ballad",
    bpmRange: "60-75",
    mood: "감성",
    deadline: "2026.04.15",
    status: "협의중",
    composer: "미정",
  },
];

export const albumProjects = [
  {
    id: "ap1",
    artist: "루나&스타즈",
    title: "Starlight EP",
    concept: "봄의 설렘과 청춘의 에너지를 담은 6트랙 EP",
    targetAudience: "15-24세 여성, MZ세대",
    trackCount: 6,
    releaseDate: "2026.05.01",
    status: "기획확정",
    producerFeedback: null,
  },
];
